import React, { useCallback, useState } from "react";
import styled, { css } from "styled-components";
import { Row, Alert, Button } from "components/bootstrap";
import { HIDE_DL_SEARCH_EXPIRED_RESULT_ALERT } from "data-lake/preview/Constants";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import Store from "logic/local-storage/Store";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const StyledButton = styled(Button)(
  ({ theme }) => css`
    margin-right: ${theme.spacings.xs};
  `
);
const ExpiredSearchInfo = ({
  expiredSearch,
  searchBarFormRef,
  filtersFromSearchType
}) => {
  const sendTelemetry = useSendTelemetry("expired-info");
  const [hideExplanation, setHideExplanation] = useState(Store.get(HIDE_DL_SEARCH_EXPIRED_RESULT_ALERT) === "true");
  const { selectedDataLake } = useSelectedDataLake();
  const hideFeatureExplanation = useCallback(() => {
    Store.set(HIDE_DL_SEARCH_EXPIRED_RESULT_ALERT, "true");
    setHideExplanation(true);
  }, []);
  const restartExpiredSearch = useCallback(() => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].APPLY_FILTER_FROM_EXPIRED_SEARCH, {
      app_pathname: "/data-storage/preview",
      event_details: {
        data_lake_storage_type: selectedDataLake.storageType
      }
    });
    const searchType = expiredSearch.queries.first().searchTypes[0];
    (_a = searchBarFormRef.current) == null ? void 0 : _a.setValues(filtersFromSearchType(searchType));
  }, [
    expiredSearch.queries,
    filtersFromSearchType,
    searchBarFormRef,
    selectedDataLake.storageType,
    selectedDataLake.type,
    sendTelemetry
  ]);
  if (hideExplanation) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "default", onDismiss: hideFeatureExplanation }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("span", null, "Your previous search has expired. Search results are stored for 24 hours and have now been cleared. You can reapply the previous filters or start a completely new search."), /* @__PURE__ */ React.createElement(StyledButton, { bsSize: "xsmall", bsStyle: "info", onClick: restartExpiredSearch }, "Reapply filters"))));
};
export default ExpiredSearchInfo;
